import React from 'react';
import styled from 'styled-components';

const EmailWrapper = styled.div`
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 1.2rem;
  @media (max-width: 768px) {
    display: none; /* Hide in mobile view */
  }

  a {
    color: #828282;
    text-decoration: none;
    position: relative;
    cursor: pointer;

     &:hover {
      color: #f5c32c; /* Yellow color on hover */
    }

    @media (max-width: 992px) {
    display: none; /* Hide social media links in mobile view */
  }

    &::after {
      content: '';
      display: block;
      width: 1px;
      height: 400px; /* Adjust the height as needed */
      background-color: #828282;
      position: absolute;
      bottom: -420px; /* Adjust this value to position the line correctly */
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const EmailLink = () => {
  const handleClick = (e) => {
    e.preventDefault();
    window.open('https://mail.google.com/mail/?view=cm&fs=1&to=adityssh.in@gmail.com', '_blank');
  };

  return (
    <EmailWrapper>
      <a href="mailto:adityssh.in@gmail.com" onClick={handleClick}>
        adityssh.in@gmail.com
      </a>
    </EmailWrapper>
  );
};

export default EmailLink;
